import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, CircularProgress, Container } from "@mui/material";
import { isBallkidEligible, getPoll, setActiveGroupSlug } from "../firebaseService";
import PollVote from "../components/PollVote";

export default function PollVotePage() {
  const { id, pollId, groupSlug } = useParams();
  const [allowed, setAllowed] = useState(null);
  const [poll, setPoll] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (groupSlug) setActiveGroupSlug(groupSlug);
    const check = async () => {
      if (!id || !pollId) {
        setAllowed(false);
        setLoading(false);
        return;
      }
      const [eligible, pollData] = await Promise.all([
        isBallkidEligible(id),
        getPoll(pollId),
      ]);
      setAllowed(eligible);
      setPoll(pollData);
      setLoading(false);
    };
    check();
  }, [id, pollId, groupSlug]);

  if (loading) {
    return <Container sx={{ textAlign: "center", mt: 4 }}><CircularProgress /></Container>;
  }

  if (!allowed) {
    return (
      <Container sx={{ mt: 4 }}>
        <Alert severity="error">Abstimmung nicht moeglich.</Alert>
      </Container>
    );
  }

  if (!poll || !poll.published) {
    return (
      <Container sx={{ mt: 4 }}>
        <Alert severity="info">Diese Abstimmung ist nicht (mehr) aktiv.</Alert>
      </Container>
    );
  }

  return <PollVote poll={poll} memberId={id} />;
}
